/** @jsx jsx */
/* eslint-disable no-use-before-define */
import { jsx } from '@emotion/core'
import { sectionCss } from '../style'

import React from 'react'
import Form from './form'
import { Formik } from 'formik'
import { ContextProvider, useQuickScreener } from './use-quick-screener'
import { publish } from '../../twd'

export default () => (
    <React.Fragment>
    <div id='corporate-quick-screener' className="vertical-offset-sm"></div>
    <div data-name='corporate-quick-screener' className="container vertical-offset-sm" css={sectionCss}>
    <div className="row vertical-offset-sm"></div>
    <ContextProvider>
        <div className="row">
        <div className="col-xs-8">
            <h3 className="medium-header">Corporate Quick Screener</h3>
        </div>
        <div className="col-xs-4 text-right">
            <button
                type="button"
                data-name="corporates-quick-screener-clear-all"
                className="link-button"
                onClick={() => { publish('corporates_quick_screener_clear_all', true) }}
            >Clear All </button>
        </div>
        </div>

        <FormMain />
    </ContextProvider>
    </div>
    </React.Fragment>)

const FormMain = () => {
    const { state, onValidate, onSubmit } = useQuickScreener()

    return (
        <Formik
            initialValues={ state.value.currentValues }
            onSubmit={onSubmit}
            component={Form}
            validate={onValidate}
            validateOnBlur={true}
            validateOnChange={true}
        />
    )
}



// WEBPACK FOOTER //
// ./src/corporates/quick-screener/quick-screener.js